import React from 'react';
import { FormattedMessage, IntlShape } from 'react-intl';

export const IMAGE_VALIDATION_MIN_WIDTH_HEIGHT_ERROR_MESSAGE = (minDimentions: number, intl: IntlShape): string =>
    intl.formatMessage({
        id: 'oe.common.error.imageMinHeightWidth',
        defaultMessage: ` should have a minimum of {minDimentions}px in width and height`,
        description: 'Error message'
    }, {
        minDimentions: minDimentions
    });

export const IMAGE_VALIDATION_MAX_WIDTH_HEIGHT_ERROR_MESSAGE = (dimentions: number, intl: IntlShape): string =>
    intl.formatMessage({
        id: 'oe.common.error.imageMinHeightWidth',
        defaultMessage: ` should be less than {dimentions}px in width and height`,
        description: 'Error message'
    }, {
        dimentions: dimentions
    });

export const FIELD_VALIDATION_PRIORITY_ERROR_MESSAGE = (min: number, max: number): JSX.Element =>
    <FormattedMessage
        id='oe.common.valueBetween'
        defaultMessage='The value must be between {min} and {max}'
        description='Error message'
        values={{
            min: min,
            max: max
        }}
    />;

export const FILE_VALIDATION_MAX_LIMIT_ERROR_MESSAGE = (maxLimit: number): JSX.Element =>
    <FormattedMessage
        id='oe.common.error.filesMaxLimit'
        defaultMessage='You can only add a maximum of {maxLimit} files'
        description='Error message'
        values={{
            maxLimit: maxLimit
        }}
    />;

export const FILE_VALIDATION_SIZE_ERROR_MESSAGE = (size: number, unit = 'MB'): JSX.Element =>
    <FormattedMessage
        id='oe.common.error.fileSize'
        defaultMessage='File is too large, maximum file size is {size} {unit}'
        description='Error message'
        values={{
            size: size,
            unit: unit
        }}
    />;

export const FIELD_IS_REQUIRED_ERROR_MESSAGE = (field: string, intl: IntlShape): string =>
    intl.formatMessage({
        id: 'oe.common.error.fieldIsRequired',
        defaultMessage: `{field} is required`,
        description: 'Error message'
    }, {
        field: field
});

export const SHORT_PLAIN_TEXT_TOO_LONG_ERROR_MESSAGE = (intl: IntlShape): string =>
    intl.formatMessage({
        id: `oe.common.error.shortPlainTextTooLong`,
        defaultMessage: 'Too long - max length is 255 characters',
        description: 'Error message text'
});

export const NOT_ALLOWED_CHARACTERS_ERROR_MESSAGE = (intl: IntlShape, characters: string): string =>
    intl.formatMessage({
        id: `oe.common.error.requiredCharacters`,
        defaultMessage: ' The following characters are not allowed: {prefix}',
        description: 'Error message text'
}, {
    prefix: characters
});

export const getAddLeastOneGroupError = (intl: IntlShape): string =>
    intl.formatMessage({
        id: `oe.common.error.addLeastOneGroup`,
        defaultMessage: 'You must add at least one Group',
        description: 'Error message text'
});

// error messages
export const TEXT_TOO_LONG_ERROR_MESSAGE = 'Text is too long';
export const REQUIRED_ERROR_MESSAGE = 'This field is required';
export const MAX_LENGTH_ERROR_MESSAGE = 'This field is required and allows 255 characters max.';
export const MAX_LENGTH_NOT_REQUIRED_ERROR_MESSAGE = 'This field allows 255 characters max.';
export const MAX_LENGTH_SHORT_PLAIN_TEXT_64_NOT_REQUIRED_ERROR_MESSAGE = 'This field allows 64 characters max.';
export const MAX_URL_LENGTH_ERROR_MESSAGE = 'This field is required and allows 2048 characters max.';
export const MAX_LENGTH_MEDIUM_PLAIN_TEXT_ERROR_MESSAGE = 'This field allows 2048 characters max.';
export const MAX_SHORT_RICH_TEXT_LENGTH_ERROR_MESSAGE = 'This field allows 16384 characters max.';
export const MAX_LONG_RICH_TEXT_LENGTH_ERROR_MESSAGE = 'This field allows 65535 characters max.';
export const MAX_INFORMATION_LENGTH_ERROR_MESSAGE = 'This field is required and allows 65535 characters max.';
export const CUSTOM_CSS_LONG_ERROR_MESSAGE = 'CSS is too long';
export const MAX_LENGTH_RICH_NOT_REQUIRED_ERROR_MESSAGE = 'This field allows 16384 characters max.';
export const MAX_OPTION_LENGTH_ERROR_MESSAGE = 'Each option allows 255 characters max.';
export const MAX_OPTIONS_COUNT_ERROR_MESSAGE = 'This field allows 250 options max.';
export const ALPHA_NUMERIC_TEXT_ERROR_MESSAGE = 'Field ID can only contain alpha-numeric characters';
export const MAGIC_LINKS_VALIDITY_DAYS_CANT_BE_GREATER_THAN_99 = `Magic Links validity days can't be greater than 99`;
export const MAGIC_LINKS_VALIDITY_DAYS_CANT_BE_LOWER_THAN_0 = `Magic Links validity days can't be lower than 0`;
export const DAYS_COUNT_BEFORE_ANONYMIZATION_ERROR_MESSAGE = 'Days count before data anonymization should be between 30 and 9999 days';
